import React from "react";
import { useTranslation } from "react-i18next";
import { LogoutButtonView } from "../buttons/LogoutButtonView";
import "./modalStyles.css";
var LogoutConfirmModal = function (_a) {
    var onClose = _a.onClose, onLogout = _a.onLogout;
    var t = useTranslation().t;
    return (React.createElement("div", { className: "modal-container" },
        React.createElement("p", { className: "info-text" }, t("logout.text")),
        React.createElement("div", null,
            React.createElement(LogoutButtonView, { onLogout: onLogout, onClose: onClose }))));
};
export default LogoutConfirmModal;



//////////////////
// WEBPACK FOOTER
// ./src/components/views/modals/LogoutConfirmModal.tsx
// module id = 156
// module chunks = 1